import InputAdornment from "@mui/material/InputAdornment";
import { InputForm } from "components/ui/inputForm";
import { useFormContext } from "react-hook-form";
import { FaUserTie } from "react-icons/fa";

export const UserInput = () => {
  const { formState } = useFormContext();
  return (
    <InputForm
      type="text"
      name="user"
      label="Usuario"
      className="w-full my-6"
      size="small"
      error={formState.errors?.user ? true : false}
      helperText={
        formState?.errors?.user ? formState?.errors?.user.message : ""
      }
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FaUserTie />
          </InputAdornment>
        ),
      }}
      rules={{
        required: {
          value: true,
          message: "El campo usuario es requerido",
        },
      }}
    />
  );
};
